import { useCallback, useEffect, useState } from 'react';
import { fetchTikTokExportCount, downloadTikTokExportXlsx } from '../services/integrationService';

// Contagem de produtos/linhas disponíveis para exportação e o download da
// planilha (.xlsx) usada na importação em massa do TikTok Shop.
export function useTikTokExport() {
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    fetchTikTokExportCount()
      .then((data) => {
        if (!active) return;
        setTotalProducts(data.totalProducts || 0);
        setTotalRows(data.totalRows || 0);
      })
      .catch(() => {
        if (active) setError('Erro ao carregar contagem.');
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const downloadSpreadsheet = useCallback(async () => {
    setDownloading(true);
    setError('');
    try {
      const blob = await downloadTikTokExportXlsx();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'tiktok-produtos.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError('Erro ao gerar planilha: ' + err.message);
    } finally {
      setDownloading(false);
    }
  }, []);

  return { totalProducts, totalRows, loading, downloading, error, downloadSpreadsheet };
}
